export const bookBoxes = [
  {
    boxName: 'Bookish & Spice',
    theme: 'Romance, Erotic, Sensual',
    description:
      'A monthly subscription box filled with spicy romance novels, themed goodies, and exclusive author swag.',
    price: '39.99',
    currency: 'AUD',
    frequency: 'Monthly',
    includedItems: [
      '1-2 spicy romance novels',
      'Bookish candle',
      'Exclusive bookmark',
      'Author signed bookplate',
      'Themed goodies (stickers, pins)',
    ],
    tags: ['romance', 'spicy', 'subscription', 'book box'],
    contentsOverview:
      'Each box focuses on a romance subgenre with a mix of new releases and fan favorites.',
    boxImage: 'https://example.com/images/bookish_and_spice_box.jpg',
    curatorImage:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    subscriptionUrl: 'https://bookishandspice.com/subscribe',
    shipping: 'Worldwide',
    customizationOptions: [
      'Choose heat level: mild, medium, hot',
      'Add extra swag pack',
    ],
    ratings: {
      average: 4.7,
      count: 350,
    },
    locationCountry: 'Australia',
    originalCurrency: 'AUD',
  },
  {
    boxName: 'Dark & Disturbed',
    theme: 'Dark Romance, Psychological Thriller',
    description:
      'A quarterly box for lovers of dark, twisted stories with intense themes and mysterious goodies.',
    price: '49.99',
    currency: 'CAD',
    frequency: 'Quarterly',
    includedItems: [
      '1-2 dark romance or thriller novels',
      'Themed candle or wax melts',
      'Mystery item (jewelry, art print)',
      'Exclusive author notes',
      "Collector's bookmark",
    ],
    tags: ['dark romance', 'thriller', 'subscription', 'book box'],
    contentsOverview:
      'Curated dark-themed boxes with exclusive merch and signed editions.',
    boxImage: 'https://example.com/images/dark_and_disturbed_box.jpg',
    curatorImage:
      'https://images.unsplash.com/photo-1614064641938-3bbee52942c7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    subscriptionUrl: 'https://darkanddisturbed.com/subscribe',
    shipping: 'US & Canada',
    customizationOptions: ['Add extra mystery item', 'Skip a quarter option'],
    ratings: {
      average: 4.9,
      count: 200,
    },
    locationCountry: 'Canada',
    originalCurrency: 'CAD',
  },
  {
    boxName: 'Fantasy Realm Crate',
    theme: 'Fantasy, Epic, Adventure',
    description:
      'A monthly box packed with fantasy novels, themed collectibles, and fan-favorite merchandise.',
    price: '44.95',
    currency: 'GBP',
    frequency: 'Monthly',
    includedItems: [
      '1-2 fantasy novels',
      'Collectible figurine or pin',
      'Themed art print',
      'Exclusive bookmark',
      'Fan merch (stickers, patches)',
    ],
    tags: ['fantasy', 'subscription', 'book box', 'collectibles'],
    contentsOverview:
      'Explore new worlds with curated fantasy picks and collectible items.',
    boxImage: 'https://example.com/images/fantasy_realm_crate.jpg',
    curatorImage:
      'https://images.unsplash.com/photo-1578950435899-d1c1bf932b1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    subscriptionUrl: 'https://fantasyrealmcrate.com/subscribe',
    shipping: 'Worldwide',
    customizationOptions: [
      'Choose preferred fantasy subgenre',
      'Add extra collectible item',
    ],
    ratings: {
      average: 4.8,
      count: 500,
    },
    locationCountry: 'United Kingdom',
    originalCurrency: 'GBP',
  },
  {
    boxName: 'Mystery Maven Box',
    theme: 'Mystery, Thriller, Suspense',
    description:
      'A bi-monthly box featuring gripping mystery novels and themed surprises to keep you on the edge of your seat.',
    price: '42.00',
    currency: 'GBP',
    frequency: 'Bi-Monthly',
    includedItems: [
      '1 mystery/thriller novel',
      'Themed candle',
      'Exclusive enamel pin',
      'Notebook for clues',
      'Surprise gift',
    ],
    tags: ['mystery', 'thriller', 'subscription', 'book box'],
    contentsOverview:
      'Perfect for mystery lovers looking for suspenseful stories and unique goodies.',
    boxImage: 'https://example.com/images/mystery_maven_box.jpg',
    curatorImage:
      'https://images.unsplash.com/photo-1571331627305-b3c24197a15b?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    subscriptionUrl: 'https://mysterymaven.co.uk/subscribe',
    shipping: 'UK & Europe',
    customizationOptions: ['Choose between thriller or classic mystery'],
    ratings: {
      average: 4.6,
      count: 150,
    },
    locationCountry: 'United Kingdom',
    originalCurrency: 'GBP',
  },
  {
    boxName: 'Otaku Reads Crate',
    theme: 'Manga, Anime, Japanese Culture',
    description:
      'Monthly manga and anime themed book box featuring graphic novels, collectibles, and Japanese snacks.',
    price: '5500',
    currency: 'JPY',
    frequency: 'Monthly',
    includedItems: [
      '2 manga volumes',
      'Anime character figurine',
      'Japanese snacks',
      'Collectible art prints',
      'Exclusive bookmarks',
    ],
    tags: ['manga', 'anime', 'subscription', 'book box', 'japanese culture'],
    contentsOverview:
      'A curated box celebrating Japanese pop culture for fans worldwide.',
    boxImage: 'https://example.com/images/otaku_reads_crate.jpg',
    curatorImage:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    subscriptionUrl: 'https://otakureads.jp/subscribe',
    shipping: 'Japan, Asia',
    customizationOptions: ['Choose manga genre: Shonen, Shojo, Seinen'],
    ratings: {
      average: 4.9,
      count: 220,
    },
    locationCountry: 'Japan',
    originalCurrency: 'JPY',
  },
  {
    boxName: 'K-Drama Book Box',
    theme: 'Korean Romance, Drama, Fiction',
    description:
      'Quarterly box inspired by popular K-Drama themes featuring novels, fan merch, and Korean snacks.',
    price: '50000',
    currency: 'KRW',
    frequency: 'Quarterly',
    includedItems: [
      '1 Korean romance novel (translated)',
      'K-Drama inspired merchandise',
      'Korean snacks',
      'Themed stationery',
      'Fan art print',
    ],
    tags: ['k-drama', 'romance', 'subscription', 'book box'],
    contentsOverview:
      'Celebrate K-Drama fandom with themed boxes filled with romance and drama.',
    boxImage: 'https://example.com/images/kdrama_book_box.jpg',
    curatorImage:
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    subscriptionUrl: 'https://kdramabox.kr/subscribe',
    shipping: 'South Korea, Worldwide',
    customizationOptions: [
      'Choose preferred genre: Romance, Thriller, Fantasy',
    ],
    ratings: {
      average: 4.8,
      count: 180,
    },
    locationCountry: 'South Korea',
    originalCurrency: 'KRW',
  },
  {
    boxName: 'Aussie Lit Crate',
    theme: 'Australian Literature & Indie Authors',
    description:
      'A monthly box featuring works by Australian authors, plus locally made bookish goodies and art.',
    price: '55.00',
    currency: 'AUD',
    frequency: 'Monthly',
    includedItems: [
      '1-2 books by Australian authors',
      'Local artisan bookmark',
      'Indie author swag',
      'Bookish candles or teas',
      'Art prints from local artists',
    ],
    tags: ['australian', 'indie', 'subscription', 'book box'],
    contentsOverview:
      'Support Aussie authors and artists with this locally curated book box.',
    boxImage: 'https://example.com/images/aussie_lit_crate.jpg',
    curatorImage:
      'https://images.unsplash.com/photo-1526280760714-f9e8b26f318f?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    subscriptionUrl: 'https://aussielitcrate.au/subscribe',
    shipping: 'Australia',
    customizationOptions: [
      'Choose hardcover or paperback',
      'Add extra swag pack',
    ],
    ratings: {
      average: 4.9,
      count: 120,
    },
    locationCountry: 'Australia',
    originalCurrency: 'AUD',
  },
  {
    boxName: 'Latin Lit Love',
    theme: 'Latin American Fiction & Culture',
    description:
      'A quarterly box celebrating Latin American authors and culture with books, artisan crafts, and recipes.',
    price: '48.00',
    currency: 'USD',
    frequency: 'Quarterly',
    includedItems: [
      '2 books by Latinx authors',
      'Handmade artisan crafts',
      'Traditional recipes booklet',
      'Bookish merchandise',
      'Exclusive author interviews',
    ],
    tags: ['latinx', 'subscription', 'book box', 'culture'],
    contentsOverview:
      'Dive into Latin American stories and traditions with this curated box.',
    boxImage: 'https://example.com/images/latin_lit_love.jpg',
    curatorImage:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    subscriptionUrl: 'https://latinlitlove.com/subscribe',
    shipping: 'US & Latin America',
    customizationOptions: ['Choose preferred book language: English, Spanish'],
    ratings: {
      average: 4.7,
      count: 95,
    },
    locationCountry: 'Mexico',
    originalCurrency: 'MXN',
  },
]
